import React from "react";
import "./published-at.m.css";
import { formatStoryDate } from "../../../helper/date-utils";

function PublishedAt({ story }) {
  const publishedDateAndTime = formatStoryDate(story && story["first-published-at"]);
  if (!publishedDateAndTime) return null;
  return <div styleName="date">Published {publishedDateAndTime} IST</div>;
}

export default PublishedAt;
